export default class InvoiceForm {
  public distributor_id: number = -1;
  public code: string = '';
  public seller_name: string = '';
  public seller_cpf: string = '';
  public items: { title: string; quant: string }[] = [];

  constructor(obj?: {
    distributor_id: number;
    code: string;
    seller_name: string;
    seller_cpf: string;
    items: { title: string; quant: string }[];
  }) {
    if (obj) {
      this.distributor_id = obj.distributor_id;
      this.code = obj.code;
      this.seller_cpf = obj.seller_name;
      this.seller_cpf = obj.seller_cpf;
      this.items = obj.items;
    }
  }
}
